import { CompatibilityVerdictForm } from '~/features/installations/components/CompatibilityVerdictForm'
import { toSuggestedCompatibility, type SuggestionFields } from '../labels'

export const ApproveCompatibilityForm = ({ installation }: { installation: SuggestionFields }) => (
  <CompatibilityVerdictForm
    installationId={installation.installation_id}
    initial={{
      meterMaker: installation.suggested_meter_maker,
      meterModel: installation.suggested_meter_model,
      installationProfile: null,
      notCompatible: toSuggestedCompatibility(installation.suggested_compatibility) === 'not_compatible'
    }}
    requireDecision
    submitLabel="Approve"
  />
)
